
import { Action             } from "@/models/action";
import { ActionType         } from "@/models/action.type";
import { Logger             } from "@/util/logger";
import { PanoramaController } from "@/components/panorama.controller";

export class PanoZoomToAction extends Action {

  /** how much to zoom by */
  public _percent = 5.0;

  /** the panoramic controller that can actually do stuff for us */
  private _controller : PanoramaController = null;

  /** standard constructor */
  constructor(controller : PanoramaController) {
    super({
      key:   ActionType.PANO_ZOOM_TO,
      type:  ActionType.PANO_ZOOM_TO,
      label: 'Zoom In',
      icon:  '',
      tip:   ''
    });

    this._controller = controller;
  }

  /** set the zoomm position (percentage 0-100) */
  public setPercent(percent: number = 5.0) {

    this._percent = percent;
  }

  /** fetch zoom position (percentage 0-100) */
  public percent(): number {

    return this._percent;
  }

  /** fetch the panoramic controller */
  public controller(): PanoramaController {

    return this._controller;
  }

  /** implement the action */
  public execute() : boolean {

    this._controller.zoomTo(this._percent);

    return true;
  }
}
